module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-circle-c83e69f6.svg";